import { render, staticRenderFns } from "./ADPLoginCallback.vue?vue&type=template&id=203fd094&"
import script from "./ADPLoginCallback.vue?vue&type=script&setup=true&lang=js&"
export * from "./ADPLoginCallback.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports